import ConfirmDelete from 'components/Global/confirmDeleteModel';
import useDebounce from 'components/Global/Hooks/UseDebounce';
import { TablePagination, TableSorter } from 'interfaces/global.interface';
import { useEffect, useState } from 'react';
import { toastText } from 'utils/utils';
import AddLeaveManagementModal from './AddLeaveManagementModal';
import LeaveManagementHeader from './Header';
import styles from './index.module.scss';
import LeaveHistoryModal from './LeaveHistoryModal';
import LeaveManagementTable from './Table';
import { leaveManagementApi } from 'Api/masters/leave-management';

const LeaveManagementComponent = () => {
	const [leaveManagementData, setLeaveManagementData] = useState<any[]>([]);
	const [isLoading, setIsLoading] = useState(false);

	const [totalRecords, setTotalRecords] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [sortField, setSortField] = useState('');
	const [sortOrder, setSortOrder] = useState('');
	const [searchText, setSearchText] = useState('');

	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
	const [deleteLeaveManagementId, setDeleteLeaveManagementId] = useState<
		string | null
	>(null);
	const [isDeleteLoading, setIsDeleteLoading] = useState<boolean>(false);

	const [isAddLeaveManagementModalOpen, setIsAddLeaveManagementModalOpen] =
		useState(false);
	const [isEdit, setIsEdit] = useState<any>(null);
	const [editData, setEditData] = useState<any>(null);

	const [configRuleModal, setConfigRuleModal] = useState(false);

	const [historyModal, setHistoryModal] = useState<boolean>(false);
	const [historyLeaveData, setHistoryLeaveData] = useState<any>({});
	const debouncedSearchValue = useDebounce(searchText, 500);
	const handleSearch = (value: string) => {
		setSearchText(value);
		setCurrentPage(1);
	};
	const handleSearchApi = async (value: string) => {
		//search api
	};

	const cancelDeleteModal = () => {
		setIsDeleteModalOpen(false);
		setDeleteLeaveManagementId(null);
	};

	const showAddLeaveManagementModal = () => {
		setIsAddLeaveManagementModalOpen(true);
	};

	const handleEdit = (data: any) => {
		setIsEdit(true);
		setEditData(data);
		showAddLeaveManagementModal();
	};

	const closeAllModals = () => {
		setIsAddLeaveManagementModalOpen(false);
		setIsEdit(false);
		setEditData(null);
		setConfigRuleModal(false);
	};

	const openConfigRuleModal = () => {
		setIsAddLeaveManagementModalOpen(false);
		setConfigRuleModal(true);
	};
	const showDeleteModal = () => {
		setIsDeleteModalOpen(true);
	};

	const openHistoryModal = (data: any) => {
		setHistoryModal(true);
		setHistoryLeaveData(data);
	};

	const handleHistoryModal = () => {
		setHistoryModal(false);
		setHistoryLeaveData({});
	};

	const deleteHandler = async () => {
		if (deleteLeaveManagementId) {
			try {
				setIsDeleteLoading(true);
				const response = await leaveManagementApi.deleteLeaveManagement(
					deleteLeaveManagementId
				);
				let message =
					response?.data?.message || 'Leave Deleted successfully';
				toastText(message, 'success');
				cancelDeleteModal();
				fetchLeaveManagementData();
			} catch (error: any) {
				const errorMessage =
					error.response?.data?.message ||
					'Something went wrong in delete leave Type';
				toastText(errorMessage, 'error');
			} finally {
				setIsDeleteLoading(false);
			}
		}
	};

	const refreshLeaveTypes = ()=>{
		setCurrentPage(1);
		fetchLeaveManagementData();
	}
	const buttons = [
		{
			text: 'Add Leave',
			isLoading: false,
			className: 'btn-blue',
			// icon: <AddSvg />,
			fontSize: '1.8rem',
			minWidth: '12rem',
			minHeight: '4rem',
			isSubmit: true,
			onclick: () => {
				setIsAddLeaveManagementModalOpen(true);
			},
			disabled: isLoading,
		},
	];
	const tableChangeHandler = (
		pagination: TablePagination,
		filters: any,
		sorter: TableSorter
	) => {
		setTotalRecords(pagination.total);
		setCurrentPage(pagination.current);
		setPageSize(pagination.pageSize);
			let order = '';
			if (sorter?.order === 'ascend') {
				order = 'asc';
			} else if (sorter?.order) {
				order = 'desc';
			}
			setSortOrder(order);
		setSortField(sorter.field);
	};

	const fetchLeaveManagementData = async () => {
		try {
			const query = {
				page: currentPage,
				searchText: debouncedSearchValue.trim(),
				sortBy: sortField,
				sortOrder: sortOrder,
				pageSize: pageSize,
			};
			setIsLoading(true);
			const leaveManagement = await leaveManagementApi.getLeaveManagement(
				query
			);

			setLeaveManagementData(leaveManagement.data.data);
			setTotalRecords(leaveManagement.data.total);
		} catch (err: any) {
			const errorMessage =
				err?.response?.data?.message ||
				'Something went wrong in fetching LeaveManagement';

			toastText(errorMessage, 'error');
		} finally {
			setIsLoading(false);
		}
	};
	useEffect(() => {
		fetchLeaveManagementData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		currentPage,
		sortField,
		sortOrder,
		pageSize,
		debouncedSearchValue,
	]);

	return (
		<>
			<div>
				<div className={styles['employee-container']}>
					<LeaveManagementHeader
						button={buttons}
						searchText={searchText}
						handleSearch={handleSearch}
						handleSearchApi={handleSearchApi}
						fetchLeaveManagementData={refreshLeaveTypes}
						isLoading={isLoading}
					/>
					<LeaveManagementTable
						leaveManagementData={leaveManagementData}
						totalRecords={totalRecords}
						currentPage={currentPage}
						pageSize={pageSize}
						isLoading={isLoading}
						handleEditData={handleEdit}
						tableChangeHandler={tableChangeHandler}
						setDeleteLeaveManagementId={setDeleteLeaveManagementId}
						showDeleteModal={showDeleteModal}
						openHistoryModal={openHistoryModal}
					/>
				</div>
			</div>
			<AddLeaveManagementModal
				open={isAddLeaveManagementModalOpen}
				handleCancel={closeAllModals}
				isEdit={isEdit}
				editData={editData}
				openConfigRuleModal={openConfigRuleModal}
				configRuleModal={configRuleModal}
				fetchLeaveManagementData={fetchLeaveManagementData}
			/>{' '}
			<ConfirmDelete
				isModalOpen={isDeleteModalOpen}
				handleCancel={cancelDeleteModal}
				deleteHandler={deleteHandler}
				isLoading={isDeleteLoading}
				handleOk={cancelDeleteModal}
			/>
			<LeaveHistoryModal
				isModalOpen={historyModal}
				handleCancel={handleHistoryModal}
				historyLeaveData={historyLeaveData}
			/>
		</>
	);
};

export default LeaveManagementComponent;
